// Interface translations: FR / EN / AR
export type UiLang = 'fr' | 'en' | 'ar';

export const UI_LANGS: { code: UiLang; label: string; flag: string; dir: 'ltr' | 'rtl' }[] = [
  { code: 'fr', label: 'Français', flag: '🇫🇷', dir: 'ltr' },
  { code: 'en', label: 'English', flag: '🇬🇧', dir: 'ltr' },
  { code: 'ar', label: 'العربية', flag: '🇸🇦', dir: 'rtl' },
];

const fr = {
  nav: { home: 'Accueil', livre: 'Le Livre', coran: 'Coran', read: 'READ', listen: 'Écouter', sourates: '114 Sourates', academy: 'Académie', learn: 'Apprendre', write: 'Écrire', qibla: 'Qibla', hijri: 'Hijri', names: '99 Noms', videos: 'Vidéos', tools: 'Outils', gallery: 'Galerie', marques: 'Marques', sciences: 'Sciences', miracles: 'Miracles', conference: 'Salle Royale', espace: 'Espace', univers: 'Univers' },
  hub: {
    levels_title: "L'Académie NDIAMSYL PEYE — 4 niveaux",
    levels_sub: 'Quatre niveaux pour maîtriser le Saint Coran, du premier alif au tafsir',
    levels_cta: 'Ouvrir le niveau',
    foriji_badge: 'Niveau 1 · Débutant',
    foriji_desc: 'L\'alphabet arabe, les harakat et la Nourania pour poser des bases solides',
    digdaum_badge: 'Niveau 2 · Intermédiaire',
    digdaum_desc: 'Les règles du Tajwid pour réciter avec justesse et beauté',
    hifz_badge: 'Niveau 3 · Avancé',
    hifz_desc: "La mémorisation du Coran et le plan de révision Muraja'a",
    kang_badge: 'Niveau 4 · Expert',
    kang_desc: 'Le Tafsir et les sciences coraniques des grands exégètes',
    quick_title: 'Explorer la plateforme',
    quick_sub: 'Le Coran complet, ses sciences et ses outils',
    realms_eyebrow: 'Tous les domaines du savoir',
    realms_title: 'Les 5 Royaumes de la Plateforme',
    realms_sub: "Sciences, Miracles, Salle Royale, Espace Membre et Univers 2500 — tous les domaines de la connaissance, au service du Livre.",
    realms_cta: 'Explorer le royaume',
    read_desc: 'Le texte arabe, la translittération et 24 langues de traduction',
    sourates_desc: 'Le Mushaf complet : 114 sourates, 6 236 versets, audio et traductions',
    listen_desc: 'Quatre grands récitateurs, verset par verset ou sourate complète',
    learn_desc: "L'alphabet arabe, ses 4 formes et la prononciation parlée",
    write_desc: 'Le tableau de traçage des lettres et les exercices de copie',
    names_desc: "Les 99 noms d'Allah expliqués, à écouter et à mémoriser",
    videos_desc: 'Des cours vidéo pour chaque niveau de l\'Académie',
    tools_desc: 'Recherche, Tasbih, comparaison de langues et progression',
    qibla_desc: 'La direction exacte de la Sainte Kaaba, où que vous soyez',
    hijri_desc: 'Le calendrier Hégirien et les jours spéciaux',
    gallery_desc: 'Éditions prestige et gamme royale en images',
    livre_desc: 'Le Livre Saint sous toutes ses graphies : KOPAH, KORAN, QURAN, Coran',
    marques_desc: '42 marques — restaurants, eaux & nectars, gammes premium',
    sciences_desc: 'Les 10 disciplines des Ulūm al-Qurʾān : révélation, tafsīr, tajwīd…',
    miracles_desc: 'Les miracles scientifiques du Coran, verset par verset',
    conference_desc: 'La salle de visioconférence royale pour apprendre ensemble',
    espace_desc: 'Identification, rang royal, Khatma, Hifz, Quiz et progression',
    univers_desc: "Explorer l'Univers du Savoir : 2500 produits dans 20 domaines",
  },
  book: {
    eyebrow: 'THE HOLY BOOK',
    title: 'THE BOOK',
    title_ar: 'القرآن الكريم',
    subtitle: 'Un seul Livre, transmis à l’humanité sous toutes ses graphies : KOPAH, KORAN, QURAN et Coran — à lire, écouter et méditer en 1000 langues.',
    access_title: 'Accéder au Livre',
    access_sub: 'Toutes les façons de lire et d’écouter le Saint Coran, réunies sur une seule page',
    access_read: 'Lire le Coran',
    access_read_desc: 'Le texte arabe, la translittération et 24 langues de traduction',
    access_listen: 'Écouter le Coran',
    access_listen_desc: 'Quatre grands récitateurs, verset par verset ou sourate complète',
    access_mushaf: '114 Sourates',
    access_mushaf_desc: 'Le Mushaf complet : 114 sourates, 6 236 versets, audio et traductions',
    access_cta: 'Ouvrir le livre',
    editions_title: 'Le Livre en images',
    editions_sub: 'Les 29 éditions prestige du Saint Coran — cliquez pour agrandir',
    editions_cta: 'Toutes les éditions',
  },
  brands: {
    eyebrow: 'KING MUHAMMAD BEN SALMAN',
    title: 'Nos Marques',
    subtitle: '42 marques — restaurants, eaux & nectars, gammes premium. Chacune avec sa page dédiée.',
    filter_all: 'Toutes',
    search_placeholder: 'Rechercher une marque…',
    visuals: 'visuels',
    season: 'Ramadan & Aïd',
    sister: 'Marques sœurs',
    all_cta: 'Toutes les marques',
    collection: 'KING MUHAMMAD BEN SALMAN · COLLECTION ROYALE',
    back: 'Toutes les marques',
    not_found: 'Marque introuvable',
    gallery_cta: 'Galerie',
  },
  hero: {
    badge: 'Plateforme Coranique Universelle',
    title: 'THE QURAN IN 1000 LANGUAGES',
    subtitle: 'Lisez, apprenez, écoutez et écrivez le Saint Coran dans toutes les langues du monde',
    cta_read: 'Commencer à lire',
    cta_listen: 'Écouter la récitation',
    stat_lang_goal: 'Langues — objectif',
    stat_lang_now: 'Langues disponibles',
    stat_surahs: 'Sourates',
    stat_ayahs: 'Versets',
    stat_editions: 'Éditions prestige',
    stat_levels: 'Niveaux d\'Académie',
    stat_sciences: 'Sciences coraniques',
    stat_products: 'Produits royaux',
    stat_note: 'Coran complet : 114 sourates, 6 236 versets + 24 langues',
  },
  voice: {
    on_hint: 'Mode vocal activé — le site parle',
    off_hint: 'Activer le mode vocal',
    badge: 'Le site parle',
  },
  read: {
    title: 'Lire le Coran',
    subtitle: 'Le texte arabe, la translittération et la traduction dans votre langue',
    select_surah: 'Sourate',
    select_translation: 'Langue de traduction',
    translation: 'Traduction',
    transliteration: 'Translittération',
    show_translit: 'Afficher la translittération',
    show_translation: 'Afficher la traduction',
    play_verse: 'Écouter ce verset',
    pause: 'Pause',
    play_all: 'Réciter toute la sourate',
    stop: 'Arrêter',
    bismillah_note: 'Au nom d\'Allah, le Tout Miséricordieux, le Très Miséricordieux',
    loading_audio: 'Chargement de l\'audio…',
    audio_error: 'Audio indisponible — vérifiez votre connexion',
    verses: 'versets',
    meccan: 'Mecquoise',
    medinan: 'Médinoise',
  },
  listen: {
    title: 'Écouter le Coran',
    subtitle: 'Récitations par de grands récitateurs, verset par verset ou sourate complète',
    select_reciter: 'Récitateur',
    reciters: {
      alafasy: 'Mishary Rashid Al-Afasy',
      husary: 'Mahmoud Khalil Al-Husary',
      sudais: 'Abdurrahman As-Sudais',
      minshawi: 'Mohamed Siddiq Al-Minshawi',
    },
    now_playing: 'En cours de lecture',
    nothing_playing: 'Aucune récitation en cours',
    verse: 'Verset',
    auto_scroll: 'Suivi automatique',
  },
  learn: {
    title: 'Apprendre le Coran',
    subtitle: 'L\'alphabet arabe, les bases de la récitation et la mémorisation',
    alphabet_title: 'L\'alphabet arabe — 28 lettres',
    letter: 'Lettre',
    name: 'Nom',
    sound: 'Prononciation',
    forms_title: 'Les formes de la lettre',
    forms_note: 'Une lettre arabe change de forme selon sa position dans le mot',
    forms: { isolated: 'Isolée', initial: 'Initiale', medial: 'Médiane', final: 'Finale' },
    basics_title: 'Les formules essentielles',
    basics: {
      bismillah: { t: 'Bismillah', d: 'Au nom d\'Allah — récitée avant chaque action' },
      shahada: { t: 'La Chahada', d: 'L\'attestation de foi : il n\'y a de divinité qu\'Allah et Muhammad est Son messager' },
      hamdala: { t: 'Al-Hamdulillah', d: 'Louange à Allah — récitée après chaque bénéfice' },
      salat: { t: 'La Salat', d: 'La prière, pilier de l\'Islam, récitée cinq fois par jour' },
    },
    memorize_title: 'Mode mémorisation',
    memorize_desc: 'Masquez la traduction et la translittération pour tester votre mémoire verset par verset',
    show_all: 'Tout afficher',
    hide_all: 'Tout masquer',
  },
  write: {
    title: 'Écrire le Coran',
    subtitle: 'Entraînez-vous à tracer les lettres arabes et à copier les versets',
    canvas_title: 'Tableau de traçage',
    canvas_desc: 'Suivez le tracé de la lettre en pointillés avec votre souris ou votre doigt',
    clear: 'Effacer',
    new_letter: 'Nouvelle lettre',
    copy_title: 'Exercice de copie',
    copy_desc: 'Recopiez le verset en calligraphie sur votre cahier, puis comparez',
    next_verse: 'Verset suivant',
    save_drawing: 'Télécharger mon tracé',
  },
  tools: {
    title: 'Les outils',
    subtitle: 'Une boîte à outils complète pour votre parcours coranique',
    search_title: 'Recherche',
    search_desc: 'Cherchez un mot dans les traductions des 5 sourates',
    search_placeholder: 'Rechercher un mot ou une expression…',
    search_empty: 'Aucun résultat',
    results: 'résultat(s)',
    bookmarks_title: 'Favoris',
    bookmarks_desc: 'Conservez vos versets préférés sur cet appareil',
    add_bookmark: 'Ajouter aux favoris',
    remove_bookmark: 'Retirer des favoris',
    no_bookmarks: 'Aucun favori pour l\'instant',
    tasbih_title: 'Compteur de Tasbih',
    tasbih_desc: 'Comptez vos dhikr : SubhanAllah, Alhamdulillah, Allahu Akbar',
    tasbih_reset: 'Remettre à zéro',
    tasbih_target: 'Objectif : 33',
    compare_title: 'Comparaison de langues',
    compare_desc: 'Affichez le même verset en deux langues côte à côte',
    language_grid_title: '24 langues de traduction',
    language_grid_desc: 'Les langues disponibles sur la plateforme aujourd\'hui — vers l\'objectif des 1000 langues',
    progress_title: 'Ma progression',
    progress_desc: 'Versets lus et écoutés sur cette session',
    read_count: 'Versets lus',
    listened_count: 'Versets écoutés',
    reset_progress: 'Réinitialiser',
  },
  gallery: {
    title: 'Galerie Royale des Produits',
    subtitle: 'Éditions prestige du Saint Coran et gamme « KING MUHAMMAD BEN SALMAN » — eaux, boissons et saveurs halal',
    coran_editions: 'Éditions du Saint Coran',
    water_range: 'Eaux & Boissons',
    restaurant_range: 'Restaurants',
    chicken_range: 'Gammes Poulets',
    beef_range: 'Bœufs Sunu Naggi',
    koran_super_range: 'Koran Super',
    all_brands: 'Toutes les marques',
    brand_filter: 'Filtrer par marque',
    perfumes_range: 'Parfums Medinatoul Rassoullulah',
    coming_soon: 'Bientôt disponible',
    count_items: 'visuels',
  },
  univers: {
    eyebrow: 'Explorer le Savoir',
    title: "L'Univers du Savoir",
    subtitle: '2500 références royales à travers 20 domaines du savoir : éditions du Coran, livres, sciences, calligraphie, parfums, saveurs halal, médias, cours et pèlerinage — un cosmos entier à explorer.',
    products: 'produits royaux',
    search_placeholder: 'Rechercher un produit, une marque…',
    sort: 'Trier',
    sort_default: 'Ordre royal',
    sort_asc: 'Prix croissant',
    sort_desc: 'Prix décroissant',
    all_brands: 'Toutes les marques',
    brand_filter: 'Filtrer par marque',
    all: 'Tout l\'Univers',
    domain: 'Domaine',
    cats: {
      coran: 'Éditions du Coran', livres_savoir: 'Livres & Savoir', mushaf_num: 'Mushaf Numérique',
      medias_audio: 'Audios', medias_video: 'Vidéos', cours_conferences: 'Cours & Conférences',
      art_calligraphie: 'Art Calligraphique', parfums: 'Parfums', encens_huiles: 'Encens & Huiles',
      cosmetique: 'Cosmétique Naturelle', dattes_miel: 'Dattes & Miel', eaux: 'Eaux & Boissons',
      koran_super: 'Koran Super', restaurants: 'Restaurants', poulets: 'Poulets',
      viandes: 'Viandes', tapis_priere: 'Tapis de Prière', tenues_priere: 'Tenues de Prière',
      pelerinage: 'Pèlerinage', enfants: 'Enfants',
    },
    prev: 'Page précédente',
    next: 'Page suivante',
    results: 'références',
    ref: 'Référence',
    order: 'Commander',
  },
  sciences: {
    title: 'Les Sciences Coraniques',
    subtitle: 'Ulūm al-Qurʾān : dix disciplines millénaires pour comprendre comment le Coran fut révélé, préservé, récité et expliqué — la carte complète du savoir coranique.',
    read: 'Explorer la discipline',
    cats: {
      all: 'Toutes', texte: 'Le Texte', sens: 'Le Sens',
      recitation: 'La Récitation', merveilles: 'Merveilles',
    },
  },
  miracles: {
    title: 'Les Miracles du Coran',
    subtitle: 'Iʿjāz ʿIlmī : les signes scientifiques du Livre — cosmos, terre, corps humain, nature et nombres — confirmés par la science moderne, verset après verset.',
    discover: 'Découvrir le miracle',
    cats: {
      all: 'Tous', cosmos: 'Cosmos', terre: 'Terre',
      humain: 'Humain', nature: 'Nature', nombres: 'Nombres',
    },
  },
  conference: {
    eyebrow: 'Visioconférence',
    title: 'La Salle Royale',
    subtitle: 'Rejoignez la salle de visioconférence NDIAMSYL PEYE : cours en direct, récitations partagées et cercles d\'étude — une salle majestueuse, où que vous soyez dans le monde.',
    welcome: 'Bienvenue dans la Salle Royale. Le cours peut commencer — As-salāmu ʿalaykum !',
    greeting: 'Wa ʿalaykum as-salām ! Ravi de vous voir dans la salle.',
    your_name: 'Votre nom',
    name_placeholder: 'Votre nom royal…',
    mic_on: 'Micro activé',
    mic_off: 'Micro coupé',
    cam_on: 'Caméra activée',
    cam_off: 'Caméra coupée',
    join: 'Rejoindre la Salle Royale',
    cam_error: 'Caméra indisponible — vous pouvez rejoindre la salle sans vidéo.',
    preview: 'Aperçu',
    peers_note: '5 participants royaux sont déjà dans la salle : Seydina, Fatou, Cheikh, Maryam et Imran.',
    room_name: 'Cercle d\'étude — Académie',
    session: 'Session',
    participants: 'participants',
    hand_up: 'Main levée',
    chat: 'Chat',
    screen_share: 'Présentation Royale',
    screen_share_note: 'Tableau de cours NDIAMSYL PEYE partagé',
    share: 'Partager',
    stop_share: 'Arrêter',
    sharing: 'présente',
    hand: 'Main',
    leave: 'Quitter',
    chat_placeholder: 'Écrire un message…',
    send: 'Envoyer',
  },
  espace: {
    eyebrow: 'Identification',
    title: "L'Espace Royal",
    subtitle: 'Créez votre espace membre : rang royal, planificateur de Khatma, tracker de mémorisation Hifz, Quiz des sciences et suivi de votre progression — votre parcours coranique, du premier alif à la Khatma.',
    signin_title: 'Entrer dans votre Espace',
    signin_sub: 'Vos données restent sur votre appareil — aucun compte externe requis.',
    name: 'Nom complet',
    email: 'Adresse email',
    city: 'Ville',
    cta: 'Ouvrir mon Espace Royal',
    privacy: 'Identification locale : votre profil est conservé uniquement dans le stockage de votre navigateur, jamais transmis.',
    benefits_title: 'Votre Espace comprend',
    benefits: [
      'Un rang royal qui grandit avec votre assiduité : Argent, Or, Royal',
      'Le planificateur de Khatma : votre date d\'achèvement des 6236 versets',
      'Le tracker Hifz : les 30 juz de mémorisation à cocher',
      'Le Quiz Royal : 8 questions sur les sciences et les miracles',
      'Votre progression : versets lus, écoutés et favoris',
      'Accès direct à la Salle Royale, la Qibla, l\'Hijri et l\'Univers',
    ],
    tools_preview_title: 'Les outils du membre',
    tools: {
      khatma: 'Plan Khatma', hifz: 'Hifz 30 juz', quiz: 'Quiz Royal', progress: 'Progression',
    },
    tiers: { silver: 'Rang Argent', gold: 'Rang Or', royal: 'Rang Royal' },
    since: 'Membre depuis le',
    signout: 'Se déconnecter',
    khatma_title: 'Planificateur de Khatma',
    khatma_sub: 'Combien de versets par jour pour achever le Mushaf ?',
    per_day: 'versets / jour',
    days_left: 'jours',
    verses: 'versets',
    khatma_note: 'La progression se calcule automatiquement à partir des versets lus dans la vue Lire.',
    hifz_title: 'Tracker Hifz — 30 Juz',
    hifz_sub: 'Cochez chaque juz mémorisé et suivez votre édifice.',
    juz: 'Juz',
    juz_done: 'juz mémorisés',
    quiz_title: 'Quiz Royal des Sciences',
    best_score: 'Meilleur score',
    quiz_bravo: 'MashāʾAllāh ! Votre rang grandit.',
    quiz_again: 'Reprenez le Quiz pour élever votre rang.',
    quiz_retry: 'Recommencer',
    question: 'Question',
    progress_title: 'Ma Progression',
    read_verses: 'Versets lus',
    listened_verses: 'Versets écoutés',
    bookmarks: 'Favoris',
    quick_title: 'Accès rapide',
  },
  footer: {
    mission: 'Une œuvre au service du Saint Coran — lire, apprendre, écouter et écrire dans 1000 langues',
    sites: 'Nos sites',
    explore: 'Explorer',
    contact: 'Contact',
    rights: 'Tous droits réservés',
    license: 'Textes coraniques et récitations : sources ouvertes (tanzil.net, islamic.network)',
    brands_col: 'Marques',
    all_brands_cta: 'Toutes les marques (42)',
  },
  readpage: {
    eyebrow: 'UNE SEULE PAGE ROYALE',
    title: 'READ',
    subtitle: "Le Livre Saint, la lecture verset par verset dans 24 langues, l'écoute avec quatre grands récitateurs et le Mushaf complet des 114 sourates — réunis sur une même page royale.",
    tab_book: 'THE BOOK',
    tab_read: 'READ',
    tab_listen: 'LISTEN',
    tab_surahs: '114 SURATS',
  },
  continents: {
    eyebrow: 'Cinq continents · Une seule Oumma',
    title: '24 langues de traduction autour du monde',
    sub: "Du Sénégal à l'Océanie, le Livre se lit dans 24 langues réunies autour des cinq continents — chaque langue est une porte ouverte sur le Coran, vers l'objectif des 1000 langues.",
    langs_label: 'langues',
  },
  books: {
    eyebrow: 'LA BIBLIOTHÈQUE ROYALE',
    title: 'Les 28 Livres du Saint Coran',
    sub: 'Vingt-huit éditions prestige sous toutes les graphies — KOPAH · KORAN · QURAN · Coran — et le Coffret Royal en exclusivité. Cliquez pour agrandir.',
    coffret_label: 'Le Coffret Royal',
    coffret_note: 'Exclusivité — photo réelle',
  },
  program: {
    eyebrow: 'Le Programme Royal',
    title: 'Sept jours de cours en direct',
    sub: 'Chaque jour a sa classe dans la Salle Royale : entrez, écoutez, récitez et progressez — du premier alif au tafsir, des enfants aux savants.',
    days: { mon: 'Lundi', tue: 'Mardi', wed: 'Mercredi', thu: 'Jeudi', fri: 'Vendredi', sat: 'Samedi', sun: 'Dimanche' },
    items: {
      mon: { name: "Foriji — L'alphabet", time: '18:00 GMT', desc: 'Lettres, harakat et Nourania : la classe des débutants, pas à pas.' },
      tue: { name: 'Digdaum — Tajwid', time: '18:00 GMT', desc: 'Les règles de récitation appliquées verset par verset, avec corrections en direct.' },
      wed: { name: "Hifz — Mémorisation", time: '17:30 GMT', desc: "Cercle de mémorisation et plan de révision Muraja'a, juz par juz." },
      thu: { name: 'Kang — Tafsir', time: '18:00 GMT', desc: 'Le sens des versets éclairé par les grands exégètes et les 10 sciences.' },
      fri: { name: 'Sciences coraniques', time: '16:00 GMT', desc: 'Ulūm al-Qurʾān : révélation, compilation, qirāʾāt — la science du Livre.' },
      sat: { name: 'Cercle des enfants', time: '11:00 GMT', desc: "L'alphabet en chansons, les grandes histoires du Coran et les 99 Noms." },
      sun: { name: 'Grande conférence', time: '10:00 GMT', desc: 'Les miracles du Coran et les merveilles de la création — conférence ouverte à tous.' },
    },
  },
  common: { language: 'Langue', interface: 'Interface', close: 'Fermer', loading: 'Chargement…' },
};

export type Dict = typeof fr;

const en: Dict = {
  nav: { home: 'Home', livre: 'The Book', coran: 'Quran', read: 'READ', listen: 'Listen', sourates: '114 Surahs', academy: 'Academy', learn: 'Learn', write: 'Write', qibla: 'Qibla', hijri: 'Hijri', names: '99 Names', videos: 'Videos', tools: 'Tools', gallery: 'Gallery', marques: 'Brands', sciences: 'Sciences', miracles: 'Miracles', conference: 'Royal Hall', espace: 'Member Space', univers: 'Universe' },
  hub: {
    levels_title: 'NDIAMSYL PEYE Academy — 4 levels',
    levels_sub: 'Four levels to master the Holy Quran, from the first alif to tafsir',
    levels_cta: 'Open level',
    foriji_badge: 'Level 1 · Beginner',
    foriji_desc: 'The Arabic alphabet, harakat and Nourania to build solid foundations',
    digdaum_badge: 'Level 2 · Intermediate',
    digdaum_desc: 'The rules of Tajwid to recite with precision and beauty',
    hifz_badge: 'Level 3 · Advanced',
    hifz_desc: "Quran memorization and the Muraja'a revision plan",
    kang_badge: 'Level 4 · Expert',
    kang_desc: 'Tafsir and Quranic sciences from the great exegetes',
    quick_title: 'Explore the platform',
    quick_sub: 'The complete Quran, its sciences and its tools',
    realms_eyebrow: 'All domains of knowledge',
    realms_title: 'The 5 Realms of the Platform',
    realms_sub: 'Sciences, Miracles, Royal Hall, Member Space and the 2500-product Universe — every domain of knowledge, in service of the Book.',
    realms_cta: 'Explore the realm',
    read_desc: 'The Arabic text, transliteration and 24 translation languages',
    sourates_desc: 'The complete Mushaf: 114 surahs, 6,236 verses, audio and translations',
    listen_desc: 'Four great reciters, verse by verse or full surah',
    learn_desc: 'The Arabic alphabet, its 4 forms and spoken pronunciation',
    write_desc: 'The letter tracing board and copying exercises',
    names_desc: 'The 99 Names of Allah explained, to listen and memorize',
    videos_desc: 'Video lessons for every level of the Academy',
    tools_desc: 'Search, Tasbih, language comparison and progress',
    qibla_desc: 'The exact direction of the Holy Kaaba, wherever you are',
    hijri_desc: 'The Hijri calendar and special days',
    gallery_desc: 'Prestige editions and the royal range in pictures',
    livre_desc: 'The Holy Book in all its spellings: KOPAH, KORAN, QURAN, Coran',
    marques_desc: '42 brands — restaurants, waters & nectars, premium ranges',
    sciences_desc: 'The 10 disciplines of ʿUlūm al-Qurʾān: revelation, tafsīr, tajwīd…',
    miracles_desc: 'The scientific miracles of the Quran, verse by verse',
    conference_desc: 'The royal video-conference hall to learn together',
    espace_desc: 'Identification, royal rank, Khatma, Hifz, Quiz and progress',
    univers_desc: "Explore the Universe of Knowledge: 2,500 products in 20 domains",
  },
  book: {
    eyebrow: 'THE HOLY BOOK',
    title: 'THE BOOK',
    title_ar: 'القرآن الكريم',
    subtitle: 'One Book, delivered to humanity in all its spellings: KOPAH, KORAN, QURAN and Coran — to read, listen to and meditate in 1000 languages.',
    access_title: 'Access the Book',
    access_sub: 'Every way to read and listen to the Holy Quran, gathered on a single page',
    access_read: 'Read the Quran',
    access_read_desc: 'The Arabic text, transliteration and 24 translation languages',
    access_listen: 'Listen to the Quran',
    access_listen_desc: 'Four great reciters, verse by verse or full surah',
    access_mushaf: '114 Surahs',
    access_mushaf_desc: 'The complete Mushaf: 114 surahs, 6,236 verses, audio and translations',
    access_cta: 'Open the book',
    editions_title: 'The Book in pictures',
    editions_sub: 'The 29 prestige editions of the Holy Quran — click to enlarge',
    editions_cta: 'All editions',
  },
  brands: {
    eyebrow: 'KING MUHAMMAD BEN SALMAN',
    title: 'Our Brands',
    subtitle: '42 brands — restaurants, waters & nectars, premium ranges. Each with its own page.',
    filter_all: 'All',
    search_placeholder: 'Search a brand…',
    visuals: 'visuals',
    season: 'Ramadan & Eid',
    sister: 'Sister brands',
    all_cta: 'All brands',
    collection: 'KING MUHAMMAD BEN SALMAN · ROYAL COLLECTION',
    back: 'All brands',
    not_found: 'Brand not found',
    gallery_cta: 'Gallery',
  },
  hero: {
    badge: 'Universal Quranic Platform',
    title: 'THE QURAN IN 1000 LANGUAGES',
    subtitle: 'Read, learn, listen to, and write the Holy Quran in every language of the world',
    cta_read: 'Start reading',
    cta_listen: 'Listen to recitation',
    stat_lang_goal: 'Languages — goal',
    stat_lang_now: 'Languages available',
    stat_surahs: 'Surahs',
    stat_ayahs: 'Verses',
    stat_editions: 'Prestige editions',
    stat_levels: 'Academy levels',
    stat_sciences: 'Quranic sciences',
    stat_products: 'Royal products',
    stat_note: 'Complete Quran: 114 surahs, 6,236 verses + 24 languages',
  },
  voice: {
    on_hint: 'Voice mode on — the site speaks',
    off_hint: 'Enable voice mode',
    badge: 'The site speaks',
  },
  read: {
    title: 'Read the Quran',
    subtitle: 'The Arabic text, transliteration and translation in your language',
    select_surah: 'Surah',
    select_translation: 'Translation language',
    translation: 'Translation',
    transliteration: 'Transliteration',
    show_translit: 'Show transliteration',
    show_translation: 'Show translation',
    play_verse: 'Play this verse',
    pause: 'Pause',
    play_all: 'Recite the whole surah',
    stop: 'Stop',
    bismillah_note: 'In the name of Allah, the Most Gracious, the Most Merciful',
    loading_audio: 'Loading audio…',
    audio_error: 'Audio unavailable — check your connection',
    verses: 'verses',
    meccan: 'Meccan',
    medinan: 'Medinan',
  },
  listen: {
    title: 'Listen to the Quran',
    subtitle: 'Recitations by world-renowned reciters, verse by verse or full surah',
    select_reciter: 'Reciter',
    reciters: {
      alafasy: 'Mishary Rashid Al-Afasy',
      husary: 'Mahmoud Khalil Al-Husary',
      sudais: 'Abdurrahman As-Sudais',
      minshawi: 'Mohamed Siddiq Al-Minshawi',
    },
    now_playing: 'Now playing',
    nothing_playing: 'Nothing playing',
    verse: 'Verse',
    auto_scroll: 'Auto-follow',
  },
  learn: {
    title: 'Learn the Quran',
    subtitle: 'The Arabic alphabet, recitation basics and memorization',
    alphabet_title: 'The Arabic alphabet — 28 letters',
    letter: 'Letter',
    name: 'Name',
    sound: 'Pronunciation',
    forms_title: 'Letter shapes',
    forms_note: 'An Arabic letter changes shape according to its position in a word',
    forms: { isolated: 'Isolated', initial: 'Initial', medial: 'Medial', final: 'Final' },
    basics_title: 'Essential formulas',
    basics: {
      bismillah: { t: 'Bismillah', d: 'In the name of Allah — recited before every action' },
      shahada: { t: 'The Shahada', d: 'The testimony of faith: there is no god but Allah, and Muhammad is His Messenger' },
      hamdala: { t: 'Al-Hamdulillah', d: 'Praise be to Allah — recited after every blessing' },
      salat: { t: 'The Salat', d: 'The prayer, pillar of Islam, recited five times a day' },
    },
    memorize_title: 'Memorization mode',
    memorize_desc: 'Hide the translation and transliteration to test your memory verse by verse',
    show_all: 'Show all',
    hide_all: 'Hide all',
  },
  write: {
    title: 'Write the Quran',
    subtitle: 'Practice tracing Arabic letters and copying verses',
    canvas_title: 'Tracing board',
    canvas_desc: 'Follow the dotted outline of the letter with your mouse or finger',
    clear: 'Clear',
    new_letter: 'New letter',
    copy_title: 'Copying exercise',
    copy_desc: 'Copy the verse in calligraphy in your notebook, then compare',
    next_verse: 'Next verse',
    save_drawing: 'Download my tracing',
  },
  tools: {
    title: 'The tools',
    subtitle: 'A complete toolbox for your Quranic journey',
    search_title: 'Search',
    search_desc: 'Search a word in the translations of the 5 surahs',
    search_placeholder: 'Search a word or phrase…',
    search_empty: 'No result',
    results: 'result(s)',
    bookmarks_title: 'Bookmarks',
    bookmarks_desc: 'Keep your favourite verses on this device',
    add_bookmark: 'Add to bookmarks',
    remove_bookmark: 'Remove from bookmarks',
    no_bookmarks: 'No bookmarks yet',
    tasbih_title: 'Tasbih Counter',
    tasbih_desc: 'Count your dhikr: SubhanAllah, Alhamdulillah, Allahu Akbar',
    tasbih_reset: 'Reset',
    tasbih_target: 'Target: 33',
    compare_title: 'Language comparison',
    compare_desc: 'Display the same verse in two languages side by side',
    language_grid_title: '24 translation languages',
    language_grid_desc: 'The languages available on the platform today — towards the 1000-language goal',
    progress_title: 'My progress',
    progress_desc: 'Verses read and listened to in this session',
    read_count: 'Verses read',
    listened_count: 'Verses listened',
    reset_progress: 'Reset',
  },
  gallery: {
    title: 'Royal Products Gallery',
    subtitle: 'Prestige editions of the Holy Quran and the « KING MUHAMMAD BEN SALMAN » range — waters, beverages and halal flavours',
    coran_editions: 'Holy Quran Editions',
    water_range: 'Waters & Beverages',
    restaurant_range: 'Restaurants',
    chicken_range: 'Chicken Ranges',
    beef_range: 'Sunu Naggi Beef',
    koran_super_range: 'Koran Super',
    all_brands: 'All brands',
    brand_filter: 'Filter by brand',
    perfumes_range: 'Medinatoul Rassoullulah Perfumes',
    coming_soon: 'Coming soon',
    count_items: 'visuals',
  },
  univers: {
    eyebrow: 'Explore Knowledge',
    title: 'The Universe of Knowledge',
    subtitle: '2,500 royal references across 20 domains of knowledge: Quran editions, books, sciences, calligraphy, perfumes, halal flavours, media, courses and pilgrimage — a whole cosmos to explore.',
    products: 'royal products',
    search_placeholder: 'Search a product, a brand…',
    sort: 'Sort',
    sort_default: 'Royal order',
    sort_asc: 'Price ascending',
    sort_desc: 'Price descending',
    all_brands: 'All brands',
    brand_filter: 'Filter by brand',
    all: 'The whole Universe',
    domain: 'Domain',
    cats: {
      coran: 'Quran Editions', livres_savoir: 'Books & Knowledge', mushaf_num: 'Digital Mushaf',
      medias_audio: 'Audios', medias_video: 'Videos', cours_conferences: 'Courses & Lectures',
      art_calligraphie: 'Calligraphy Art', parfums: 'Perfumes', encens_huiles: 'Incense & Oils',
      cosmetique: 'Natural Cosmetics', dattes_miel: 'Dates & Honey', eaux: 'Waters & Beverages',
      koran_super: 'Koran Super', restaurants: 'Restaurants', poulets: 'Chickens',
      viandes: 'Meats', tapis_priere: 'Prayer Rugs', tenues_priere: 'Prayer Garments',
      pelerinage: 'Pilgrimage', enfants: 'Children',
    },
    prev: 'Previous page',
    next: 'Next page',
    results: 'references',
    ref: 'Reference',
    order: 'Order now',
  },
  sciences: {
    title: 'Quranic Sciences',
    subtitle: 'ʿUlūm al-Qurʾān: ten age-old disciplines to understand how the Quran was revealed, preserved, recited and explained — the complete map of Quranic knowledge.',
    read: 'Explore the discipline',
    cats: {
      all: 'All', texte: 'The Text', sens: 'The Meaning',
      recitation: 'Recitation', merveilles: 'Wonders',
    },
  },
  miracles: {
    title: 'The Miracles of the Quran',
    subtitle: 'Iʿjāz ʿIlmī: the scientific signs of the Book — cosmos, earth, human body, nature and numbers — confirmed by modern science, verse after verse.',
    discover: 'Discover the miracle',
    cats: {
      all: 'All', cosmos: 'Cosmos', terre: 'Earth',
      humain: 'Human', nature: 'Nature', nombres: 'Numbers',
    },
  },
  conference: {
    eyebrow: 'Video Conference',
    title: 'The Royal Hall',
    subtitle: 'Join the NDIAMSYL PEYE video-conference hall: live lessons, shared recitations and study circles — a majestic room, wherever you are in the world.',
    welcome: 'Welcome to the Royal Hall. The lesson may begin — As-salāmu ʿalaykum!',
    greeting: 'Wa ʿalaykum as-salām! Glad to see you in the hall.',
    your_name: 'Your name',
    name_placeholder: 'Your royal name…',
    mic_on: 'Mic on',
    mic_off: 'Mic muted',
    cam_on: 'Camera on',
    cam_off: 'Camera off',
    join: 'Join the Royal Hall',
    cam_error: 'Camera unavailable — you can still join the hall without video.',
    preview: 'Preview',
    peers_note: '5 royal participants are already in the hall: Seydina, Fatou, Cheikh, Maryam and Imran.',
    room_name: 'Study Circle — Academy',
    session: 'Session',
    participants: 'participants',
    hand_up: 'Hand raised',
    chat: 'Chat',
    screen_share: 'Royal Presentation',
    screen_share_note: 'NDIAMSYL PEYE lesson board shared',
    share: 'Share',
    stop_share: 'Stop',
    sharing: 'presenting',
    hand: 'Hand',
    leave: 'Leave',
    chat_placeholder: 'Write a message…',
    send: 'Send',
  },
  espace: {
    eyebrow: 'Identification',
    title: 'The Royal Space',
    subtitle: 'Create your member space: royal rank, Khatma planner, Hifz memorization tracker, sciences Quiz and progress tracking — your Quranic journey, from the first alif to the Khatma.',
    signin_title: 'Enter your Space',
    signin_sub: 'Your data stays on your device — no external account required.',
    name: 'Full name',
    email: 'Email address',
    city: 'City',
    cta: 'Open my Royal Space',
    privacy: 'Local identification: your profile is kept only in your browser storage, never transmitted.',
    benefits_title: 'Your Space includes',
    benefits: [
      'A royal rank that grows with your dedication: Silver, Gold, Royal',
      'The Khatma planner: your completion date for the 6,236 verses',
      'The Hifz tracker: the 30 memorization juz to tick off',
      'The Royal Quiz: 8 questions on sciences and miracles',
      'Your progress: verses read, listened to and bookmarked',
      'Direct access to the Royal Hall, Qibla, Hijri and the Universe',
    ],
    tools_preview_title: 'Member tools',
    tools: {
      khatma: 'Khatma Plan', hifz: 'Hifz 30 juz', quiz: 'Royal Quiz', progress: 'Progress',
    },
    tiers: { silver: 'Silver Rank', gold: 'Gold Rank', royal: 'Royal Rank' },
    since: 'Member since',
    signout: 'Sign out',
    khatma_title: 'Khatma Planner',
    khatma_sub: 'How many verses per day to complete the Mushaf?',
    per_day: 'verses / day',
    days_left: 'days',
    verses: 'verses',
    khatma_note: 'Progress is computed automatically from the verses read in the Read view.',
    hifz_title: 'Hifz Tracker — 30 Juz',
    hifz_sub: 'Tick each memorized juz and watch your edifice grow.',
    juz: 'Juz',
    juz_done: 'juz memorized',
    quiz_title: 'Royal Sciences Quiz',
    best_score: 'Best score',
    quiz_bravo: 'MashāʾAllāh! Your rank grows.',
    quiz_again: 'Take the Quiz again to raise your rank.',
    quiz_retry: 'Start again',
    question: 'Question',
    progress_title: 'My Progress',
    read_verses: 'Verses read',
    listened_verses: 'Verses listened',
    bookmarks: 'Bookmarks',
    quick_title: 'Quick access',
  },
  footer: {
    mission: 'A work in the service of the Holy Quran — read, learn, listen and write in 1000 languages',
    sites: 'Our websites',
    explore: 'Explore',
    contact: 'Contact',
    rights: 'All rights reserved',
    license: 'Quranic texts and recitations: open sources (tanzil.net, islamic.network)',
    brands_col: 'Brands',
    all_brands_cta: 'All brands (42)',
  },
  readpage: {
    eyebrow: 'ONE ROYAL PAGE',
    title: 'READ',
    subtitle: 'The Holy Book, verse-by-verse reading in 24 languages, listening with four great reciters and the complete Mushaf of 114 surahs — gathered on one royal page.',
    tab_book: 'THE BOOK',
    tab_read: 'READ',
    tab_listen: 'LISTEN',
    tab_surahs: '114 SURATS',
  },
  continents: {
    eyebrow: 'Five continents · One Ummah',
    title: '24 translation languages around the world',
    sub: "From Senegal to Oceania, the Book is read in 24 languages gathered around the five continents — every language is a door opening onto the Quran, towards the 1000-language goal.",
    langs_label: 'languages',
  },
  books: {
    eyebrow: 'THE ROYAL LIBRARY',
    title: 'The 28 Books of the Holy Quran',
    sub: 'Twenty-eight prestige editions in every spelling — KOPAH · KORAN · QURAN · Coran — and the Royal Coffret as an exclusive. Click to enlarge.',
    coffret_label: 'The Royal Coffret',
    coffret_note: 'Exclusive — real photo',
  },
  program: {
    eyebrow: 'The Royal Programme',
    title: 'Seven days of live lessons',
    sub: 'Every day has its own class in the Royal Hall: join, listen, recite and progress — from the first alif to tafsir, from children to scholars.',
    days: { mon: 'Monday', tue: 'Tuesday', wed: 'Wednesday', thu: 'Thursday', fri: 'Friday', sat: 'Saturday', sun: 'Sunday' },
    items: {
      mon: { name: 'Foriji — Alphabet', time: '18:00 GMT', desc: 'Letters, harakat and Nourania: the beginners class, step by step.' },
      tue: { name: 'Digdaum — Tajwid', time: '18:00 GMT', desc: 'Recitation rules applied verse by verse, with live correction.' },
      wed: { name: 'Hifz — Memorization', time: '17:30 GMT', desc: "Memorization circle and the Muraja'a revision plan, juz by juz." },
      thu: { name: 'Kang — Tafsir', time: '18:00 GMT', desc: 'The meaning of the verses illuminated by the great exegetes and the 10 sciences.' },
      fri: { name: 'Quranic Sciences', time: '16:00 GMT', desc: 'ʿUlūm al-Qurʾān: revelation, compilation, qirāʾāt — the science of the Book.' },
      sat: { name: 'Children Circle', time: '11:00 GMT', desc: 'The alphabet in songs, the great stories of the Quran and the 99 Names.' },
      sun: { name: 'Grand Conference', time: '10:00 GMT', desc: 'The miracles of the Quran and the wonders of creation — open to all.' },
    },
  },
  common: { language: 'Language', interface: 'Interface', close: 'Close', loading: 'Loading…' },
};

const ar: Dict = {
  nav: { home: 'الرئيسية', livre: 'الكتاب', coran: 'القرآن', read: 'READ', listen: 'استمع', sourates: 'السور الـ١١٤', academy: 'الأكاديمية', learn: 'تعلم', write: 'اكتب', qibla: 'القبلة', hijri: 'الهجري', names: 'أسماء الله', videos: 'الفيديو', tools: 'الأدوات', gallery: 'المعرض', marques: 'العلامات', sciences: 'العلوم', miracles: 'المعجزات', conference: 'القاعة الملكية', espace: 'فضاء الأعضاء', univers: 'الكون' },
  hub: {
    levels_title: 'أكاديمية نجامسل باي — أربعة مستويات',
    levels_sub: 'أربعة مستويات لإتقان القرآن الكريم، من أول ألف إلى التفسير',
    levels_cta: 'افتح المستوى',
    foriji_badge: 'المستوى ١ · مبتدئ',
    foriji_desc: 'الحروف العربية والحركات والنورانية لبناء أساس متين',
    digdaum_badge: 'المستوى ٢ · متوسط',
    digdaum_desc: 'أحكام التجويد للتلاوة بدقة وجمال',
    hifz_badge: 'المستوى ٣ · متقدم',
    hifz_desc: 'حفظ القرآن الكريم وخطة المراجعة',
    kang_badge: 'المستوى ٤ · متقدم جدًا',
    kang_desc: 'التفسير وعلوم القرآن عند كبار المفسرين',
    quick_title: 'استكشف المنصة',
    quick_sub: 'القرآن كاملاً وعلومه وأدواته',
    realms_eyebrow: 'جميع مجالات المعرفة',
    realms_title: 'الممالك الخمس للمنصة',
    realms_sub: 'العلوم والمعجزات والقاعة الملكية وفضاء الأعضاء وكون الـ٢٥٠٠ منتجًا — كل مجالات المعرفة في خدمة الكتاب.',
    realms_cta: 'استكشف المملكة',
    read_desc: 'النص العربي والنسخ اللاتيني و٢٤ لغة ترجمة',
    sourates_desc: 'المصحف الكامل: ١١٤ سورة، ٦٢٣٦ آية، صوت وترجمات',
    listen_desc: 'أربعة قراء كبار، آية بآية أو سورة كاملة',
    learn_desc: 'الحروف العربية وأشكالها الأربعة والنطق المسموع',
    write_desc: 'لوحة تدريب الحروف وتمارين النسخ',
    names_desc: 'أسماء الله الحسنى التسعة والتسعون مشروحة للاستماع والحفظ',
    videos_desc: 'دروس فيديو لكل مستوى من مستويات الأكاديمية',
    tools_desc: 'البحث والتسبيح ومقارنة اللغات والتقدم',
    qibla_desc: 'اتجاه الكعبة المشرفة بدقة، من أي مكان',
    hijri_desc: 'التقويم الهجري والأيام المخصوصة',
    gallery_desc: 'الإصدارات الفاخرة والمجموعة الملكية بالصور',
    livre_desc: 'الكتاب المقدس بكل رسوماته: كوباه، كوران، قرآن، قرأن',
    marques_desc: '٤٢ علامة — مطاعم ومياه ونسائم وفئات فاخرة',
    sciences_desc: 'عشر علوم من علوم القرآن: الوحي والتفسير والتجويد…',
    miracles_desc: 'المعجزات العلمية للقرآن آية بآية',
    conference_desc: 'قاعة الاجتماعات الملكية للتعلم معًا',
    espace_desc: 'التعريف والرتبة الملكية والختمة والحفظ والاختبار والتقدم',
    univers_desc: 'استكشف كون المعرفة: ٢٥٠٠ منتج في ٢٠ مجالًا',
  },
  book: {
    eyebrow: 'الكتاب المقدس',
    title: 'الكتاب',
    title_ar: 'القرآن الكريم',
    subtitle: 'كتاب واحد، أوتي البشرية بجميع رسوماته: كوباه وكوران وقرآن وقرأن — ليُقرأ ويُسمع ويُتدبَّر بـ١٠٠٠ لغة.',
    access_title: 'الوصول إلى الكتاب',
    access_sub: 'جميع طرق قراءة القرآن الكريم والاستماع إليه، في صفحة واحدة',
    access_read: 'اقرأ القرآن',
    access_read_desc: 'النص العربي والنسخ اللاتيني و٢٤ لغة ترجمة',
    access_listen: 'استمع إلى القرآن',
    access_listen_desc: 'أربعة قراء كبار، آية بآية أو سورة كاملة',
    access_mushaf: 'السور الـ١١٤',
    access_mushaf_desc: 'المصحف الكامل: ١١٤ سورة، ٦٢٣٦ آية، صوت وترجمات',
    access_cta: 'افتح الكتاب',
    editions_title: 'الكتاب بالصور',
    editions_sub: 'الإصدارات الـ٢٩ الفاخرة للقرآن الكريم — انقر للتكبير',
    editions_cta: 'جميع الإصدارات',
  },
  brands: {
    eyebrow: 'الملك محمد بن سلمان',
    title: 'علاماتنا',
    subtitle: '٤٢ علامة — مطاعم ومياه ونسائم وفئات فاخرة. لكل منها صفحة خاصة.',
    filter_all: 'الكل',
    search_placeholder: 'ابحث عن علامة…',
    visuals: 'صورة',
    season: 'رمضان والعيد',
    sister: 'علامات شقيقة',
    all_cta: 'جميع العلامات',
    collection: 'الملك محمد بن سلمان · المجموعة الملكية',
    back: 'جميع العلامات',
    not_found: 'العلامة غير موجودة',
    gallery_cta: 'المعرض',
  },
  hero: {
    badge: 'المنصة القرآنية العالمية',
    title: 'القرآن الكريم بـ 1000 لغة',
    subtitle: 'اقرأ وتعلم واستمع واكتب القرآن الكريم بكل لغات العالم',
    cta_read: 'ابدأ القراءة',
    cta_listen: 'استمع إلى التلاوة',
    stat_lang_goal: 'لغة — الهدف',
    stat_lang_now: 'لغة متوفرة',
    stat_surahs: 'سورة',
    stat_ayahs: 'آية',
    stat_editions: 'إصدارًا فاخرًا',
    stat_levels: 'مستويات الأكاديمية',
    stat_sciences: 'علومًا قرآنية',
    stat_products: 'منتجًا ملكيًا',
    stat_note: 'القرآن كاملاً: ١١٤ سورة، ٦٢٣٦ آية + ٢٤ لغة',
  },
  voice: {
    on_hint: 'الوضع الصوتي مفعّل — الموقع يتكلم',
    off_hint: 'تفعيل الوضع الصوتي',
    badge: 'الموقع يتكلم',
  },
  read: {
    title: 'اقرأ القرآن الكريم',
    subtitle: 'النص العربي والنسخ اللاتيني والترجمة بلغتك',
    select_surah: 'السورة',
    select_translation: 'لغة الترجمة',
    translation: 'الترجمة',
    transliteration: 'النسخ اللاتيني',
    show_translit: 'إظهار النسخ اللاتيني',
    show_translation: 'إظهار الترجمة',
    play_verse: 'استمع إلى هذه الآية',
    pause: 'إيقاف مؤقت',
    play_all: 'تلاوة السورة كاملة',
    stop: 'إيقاف',
    bismillah_note: 'بسم الله الرحمن الرحيم',
    loading_audio: 'جارٍ تحميل الصوت…',
    audio_error: 'الصوت غير متاح — تحقق من اتصالك',
    verses: 'آيات',
    meccan: 'مكية',
    medinan: 'مدنية',
  },
  listen: {
    title: 'استمع إلى القرآن الكريم',
    subtitle: 'تلاوات كبار القراء، آية بآية أو سورة كاملة',
    select_reciter: 'القارئ',
    reciters: {
      alafasy: 'مشاري راشد العفاسي',
      husary: 'محمود خليل الحصري',
      sudais: 'عبد الرحمن السديس',
      minshawi: 'محمد صديق المنشاوي',
    },
    now_playing: 'قيد التشغيل',
    nothing_playing: 'لا توجد تلاوة قيد التشغيل',
    verse: 'الآية',
    auto_scroll: 'متابعة تلقائية',
  },
  learn: {
    title: 'تعلم القرآن الكريم',
    subtitle: 'الحروف العربية وأساسيات التلاوة والحفظ',
    alphabet_title: 'الحروف العربية — 28 حرفًا',
    letter: 'الحرف',
    name: 'الاسم',
    sound: 'النطق',
    forms_title: 'أشكال الحرف',
    forms_note: 'يتغير شكل الحرف العربي حسب موقعه في الكلمة',
    forms: { isolated: 'منفصل', initial: 'أول', medial: 'وسط', final: 'آخر' },
    basics_title: 'الصيغ الأساسية',
    basics: {
      bismillah: { t: 'البسملة', d: 'بسم الله — تُقال قبل كل عمل' },
      shahada: { t: 'الشهادة', d: 'شهادة أن لا إله إلا الله وأن محمدًا رسول الله' },
      hamdala: { t: 'الحمد لله', d: 'الحمد لله — تُقال بعد كل نعمة' },
      salat: { t: 'الصلاة', d: 'صلاة، عمود الإسلام، تؤدى خمس مرات يوميًا' },
    },
    memorize_title: 'وضع الحفظ',
    memorize_desc: 'أخفِ الترجمة والنسخ اللاتيني لاختبار ذاكرتك آية بآية',
    show_all: 'إظهار الكل',
    hide_all: 'إخفاء الكل',
  },
  write: {
    title: 'اكتب القرآن الكريم',
    subtitle: 'تدرب على رسم الحروف العربية ونسخ الآيات',
    canvas_title: 'لوحة التدريب',
    canvas_desc: 'اتبع الخط المتقطع للحرف بالفأرة أو بإصبعك',
    clear: 'محو',
    new_letter: 'حرف جديد',
    copy_title: 'تمرين النسخ',
    copy_desc: 'انسخ الآية بخط الجميل في دفترك ثم قارن',
    next_verse: 'الآية التالية',
    save_drawing: 'تحميل رسمتي',
  },
  tools: {
    title: 'الأدوات',
    subtitle: 'صندوق أدوات كامل لرحلتك القرآنية',
    search_title: 'البحث',
    search_desc: 'ابحث عن كلمة في ترجمات السور الخمس',
    search_placeholder: 'ابحث عن كلمة أو عبارة…',
    search_empty: 'لا توجد نتائج',
    results: 'نتيجة',
    bookmarks_title: 'المفضلة',
    bookmarks_desc: 'احفظ آياتك المفضلة على هذا الجهاز',
    add_bookmark: 'أضف إلى المفضلة',
    remove_bookmark: 'إزالة من المفضلة',
    no_bookmarks: 'لا توجد مفضلات بعد',
    tasbih_title: 'عداد التسبيح',
    tasbih_desc: 'عد ذكرك: سبحان الله، الحمد لله، الله أكبر',
    tasbih_reset: 'إعادة الضبط',
    tasbih_target: 'الهدف: 33',
    compare_title: 'مقارنة اللغات',
    compare_desc: 'اعرض الآية نفسها بلغتين جنبًا إلى جنب',
    language_grid_title: '٢٤ لغة ترجمة',
    language_grid_desc: 'اللغات المتوفرة على المنصة اليوم — نحو هدف الألف لغة',
    progress_title: 'تقدمي',
    progress_desc: 'الآيات المقروءة والمسموعة في هذه الجلسة',
    read_count: 'الآيات المقروءة',
    listened_count: 'الآيات المسموعة',
    reset_progress: 'إعادة تعيين',
  },
  gallery: {
    title: 'المعرض الملكي للمنتجات',
    subtitle: 'إصدارات فاخرة من القرآن الكريم ومجموعة « الملك محمد بن سلمان » — مياه ومشروبات ونكهات حلال',
    coran_editions: 'إصدارات القرآن الكريم',
    water_range: 'المياه والمشروبات',
    restaurant_range: 'المطاعم',
    chicken_range: 'منتجات الدجاج',
    beef_range: 'لحوم سونو ناغي',
    koran_super_range: 'كوران سوبر',
    all_brands: 'جميع العلامات',
    brand_filter: 'تصفية حسب العلامة',
    perfumes_range: 'عطور المدينة الرسول',
    coming_soon: 'قريبًا',
    count_items: 'صورة',
  },
  univers: {
    eyebrow: 'استكشف المعرفة',
    title: 'كون المعرفة',
    subtitle: '٢٥٠٠ مرجع ملكي في ٢٠ مجالًا من المعرفة: إصدارات القرآن والكتب والعلوم والخط والعطور والنكهات الحلال والإعلام والدروس والحج — كون كامل لاستكشافه.',
    products: 'منتجًا ملكيًا',
    search_placeholder: 'ابحث عن منتج أو علامة…',
    sort: 'ترتيب',
    sort_default: 'الترتيب الملكي',
    sort_asc: 'السعر تصاعديًا',
    sort_desc: 'السعر تنازليًا',
    all_brands: 'جميع العلامات',
    brand_filter: 'تصفية حسب العلامة',
    all: 'الكون كله',
    domain: 'المجال',
    cats: {
      coran: 'إصدارات القرآن', livres_savoir: 'الكتب والمعرفة', mushaf_num: 'المصحف الرقمي',
      medias_audio: 'الصوتيات', medias_video: 'المرئيات', cours_conferences: 'الدروس والمحاضرات',
      art_calligraphie: 'فن الخط', parfums: 'العطور', encens_huiles: 'البخور والزيوت',
      cosmetique: 'التجميل الطبيعي', dattes_miel: 'التمور والعسل', eaux: 'المياه والمشروبات',
      koran_super: 'كوران سوبر', restaurants: 'المطاعم', poulets: 'الدجاج',
      viandes: 'اللحوم', tapis_priere: 'سجاد الصلاة', tenues_priere: 'ملابس الصلاة',
      pelerinage: 'الحج والعمرة', enfants: 'الأطفال',
    },
    prev: 'الصفحة السابقة',
    next: 'الصفحة التالية',
    results: 'مرجعًا',
    ref: 'المرجع',
    order: 'اطلب الآن',
  },
  sciences: {
    title: 'علوم القرآن',
    subtitle: 'علوم القرآن: عشرة فنون عريقة لفهم كيف نزل القرآن وحُفظ وتُلِي وفُسِّر — خريطة كاملة للمعرفة القرآنية.',
    read: 'استكشف العلم',
    cats: {
      all: 'الكل', texte: 'النص', sens: 'المعنى',
      recitation: 'التلاوة', merveilles: 'عجائب',
    },
  },
  miracles: {
    title: 'معجزات القرآن',
    subtitle: 'الإعجاز العلمي: آيات الكتاب العلمية — الكون والأرض وجسم الإنسان والطبيعة والأرقام — أكدتها العلوم الحديثة، آية بعد آية.',
    discover: 'اكتشف المعجزة',
    cats: {
      all: 'الكل', cosmos: 'الكون', terre: 'الأرض',
      humain: 'الإنسان', nature: 'الطبيعة', nombres: 'الأرقام',
    },
  },
  conference: {
    eyebrow: 'اجتماع مرئي',
    title: 'القاعة الملكية',
    subtitle: 'انضم إلى قاعة الاجتماعات المرئية لأكاديمية نجامسل باي: دروس مباشرة وتلاوات مشتركة وحلقات دراسة — قاعة مهيبة أينما كنت في العالم.',
    welcome: 'مرحبًا بكم في القاعة الملكية. يمكن أن يبدأ الدرس — السلام عليكم!',
    greeting: 'وعليكم السلام! سعداء برؤيتكم في القاعة.',
    your_name: 'اسمك',
    name_placeholder: 'اسمك الملكي…',
    mic_on: 'الميكروفون يعمل',
    mic_off: 'الميكروفون مغلق',
    cam_on: 'الكاميرا تعمل',
    cam_off: 'الكاميرا مغلقة',
    join: 'انضم إلى القاعة الملكية',
    cam_error: 'الكاميرا غير متاحة — يمكنك الانضمام دون فيديو.',
    preview: 'معاينة',
    peers_note: '٥ مشاركين ملكيين في القاعة بالفعل: سيدنا، فاتو، الشيخ، مريم وعمران.',
    room_name: 'حلقة دراسة — الأكاديمية',
    session: 'الجلسة',
    participants: 'مشاركين',
    hand_up: 'يد مرفوعة',
    chat: 'الدردشة',
    screen_share: 'عرض ملكي',
    screen_share_note: 'لوحة دروس أكاديمية نجامسل باي مشتركة',
    share: 'شارك',
    stop_share: 'إيقاف',
    sharing: 'يعرض',
    hand: 'اليد',
    leave: 'مغادرة',
    chat_placeholder: 'اكتب رسالة…',
    send: 'أرسل',
  },
  espace: {
    eyebrow: 'التعريف',
    title: 'الفضاء الملكي',
    subtitle: 'أنشئ فضاء العضوية: الرتبة الملكية، ومخطط الختمة، ومتتبع الحفظ، واختبار العلوم، وتتبع تقدمك — رحلتك القرآنية من أول ألف إلى الختمة.',
    signin_title: 'ادخل فضاءك',
    signin_sub: 'بياناتك تبقى على جهازك — لا حاجة لأي حساب خارجي.',
    name: 'الاسم الكامل',
    email: 'البريد الإلكتروني',
    city: 'المدينة',
    cta: 'افتح فضائي الملكي',
    privacy: 'تعريف محلي: ملفك محفوظ فقط في متصفحك، ولا يُرسل أبدًا.',
    benefits_title: 'يشمل فضاؤك',
    benefits: [
      'رتبة ملكية تنمو مع مواظبتك: فضية، ذهبية، ملكية',
      'مخطط الختمة: تاريخ إتمامك للآيات الـ٦٢٣٦',
      'متتبع الحفظ: الأجزاء الـ٣٠ لتأشيرها',
      'الاختبار الملكي: ٨ أسئلة عن العلوم والمعجزات',
      'تقدمك: الآيات المقروءة والمسموعة والمفضلة',
      'وصول مباشر إلى القاعة الملكية والقبلة والهجري والكون',
    ],
    tools_preview_title: 'أدوات العضو',
    tools: {
      khatma: 'مخطط الختمة', hifz: 'حفظ ٣٠ جزءًا', quiz: 'الاختبار الملكي', progress: 'التقدم',
    },
    tiers: { silver: 'رتبة فضية', gold: 'رتبة ذهبية', royal: 'رتبة ملكية' },
    since: 'عضو منذ',
    signout: 'تسجيل الخروج',
    khatma_title: 'مخطط الختمة',
    khatma_sub: 'كم آية في اليوم لإتمام المصحف؟',
    per_day: 'آية / يوم',
    days_left: 'يومًا',
    verses: 'آية',
    khatma_note: 'يُحسب التقدم تلقائيًا من الآيات المقروءة في واجهة القراءة.',
    hifz_title: 'متتبع الحفظ — ٣٠ جزءًا',
    hifz_sub: 'أشِّر كل جزء تحفظه وشاهد بنايتك تنمو.',
    juz: 'الجزء',
    juz_done: 'جزءًا محفوظًا',
    quiz_title: 'الاختبار الملكي للعلوم',
    best_score: 'أفضل نتيجة',
    quiz_bravo: 'ما شاء الله! رتبتك تنمو.',
    quiz_again: 'أعد الاختبار لترفع رتبتك.',
    quiz_retry: 'ابدأ من جديد',
    question: 'سؤال',
    progress_title: 'تقدمي',
    read_verses: 'الآيات المقروءة',
    listened_verses: 'الآيات المسموعة',
    bookmarks: 'المفضلة',
    quick_title: 'وصول سريع',
  },
  footer: {
    mission: 'عمل في خدمة القرآن الكريم — قراءة وتعلم واستماع وكتابة بـ 1000 لغة',
    sites: 'مواقعنا',
    explore: 'استكشف',
    contact: 'اتصل بنا',
    rights: 'جميع الحقوق محفوظة',
    license: 'النصوص القرآنية والتلاوات: مصادر مفتوحة (تنزيل.نت، إسلاميك.نتورك)',
    brands_col: 'العلامات',
    all_brands_cta: 'جميع العلامات (٤٢)',
  },
  readpage: {
    eyebrow: 'صفحة ملكية واحدة',
    title: 'اقرأ',
    subtitle: 'الكتاب المقدس والقراءة آية بآية بـ٢٤ لغة والاستماع بأربعة قراء كبار والمصحف الكامل للسور الـ١١٤ — في صفحة ملكية واحدة.',
    tab_book: 'الكتاب',
    tab_read: 'اقرأ',
    tab_listen: 'استمع',
    tab_surahs: 'السور الـ١١٤',
  },
  continents: {
    eyebrow: 'خمس قارات · أمة واحدة',
    title: '٢٤ لغة ترجمة حول العالم',
    sub: 'من السنغال إلى أوقيانوسيا، يُقرأ الكتاب بـ٢٤ لغة تجتمع حول القارات الخمس — كل لغة باب يفتح على القرآن، نحو هدف الألف لغة.',
    langs_label: 'لغات',
  },
  books: {
    eyebrow: 'المكتبة الملكية',
    title: 'كتب القرآن الكريم الـ٢٨',
    sub: 'ثمانية وعشرون إصدارًا فاخرًا بجميع الرسومات — كوباه · كوران · قرآن · قرأن — والصندوق الملكي حصريًا. انقر للتكبير.',
    coffret_label: 'الصندوق الملكي',
    coffret_note: 'حصري — صورة حقيقية',
  },
  program: {
    eyebrow: 'البرنامج الملكي',
    title: 'سبعة أيام من الدروس المباشرة',
    sub: 'لكل يوم درسه في القاعة الملكية: ادخل واستمع وتلوت وتقدم — من أول ألف إلى التفسير، من الأطفال إلى العلماء.',
    days: { mon: 'الاثنين', tue: 'الثلاثاء', wed: 'الأربعاء', thu: 'الخميس', fri: 'الجمعة', sat: 'السبت', sun: 'الأحد' },
    items: {
      mon: { name: 'الفُرْجِي — الحروف', time: '١٨:٠٠ غرينتش', desc: 'الحروف والحركات والنورانية: درس المبتدئين خطوة بخطوة.' },
      tue: { name: 'الدِّدْغَام — التجويد', time: '١٨:٠٠ غرينتش', desc: 'أحكام التلاوة مطبقة آية بآية، مع تصحيح مباشر.' },
      wed: { name: 'حِفْظ — الحفظ', time: '١٧:٣٠ غرينتش', desc: 'حلقة الحفظ وخطة المراجعة، جزءًا جزءًا.' },
      thu: { name: 'كَانْغ — التفسير', time: '١٨:٠٠ غرينتش', desc: 'معاني الآيات عند كبار المفسرين والعشر علوم.' },
      fri: { name: 'علوم القرآن', time: '١٦:٠٠ غرينتش', desc: 'الوحي والجمع والقراءات — علم الكتاب.' },
      sat: { name: 'حلقة الأطفال', time: '١١:٠٠ غرينتش', desc: 'الحروف بالأناشيد وقصص القرآن العظيمة والأسماء الحسنى.' },
      sun: { name: 'المؤتمر الكبير', time: '١٠:٠٠ غرينتش', desc: 'معجزات القرآن وعجائب الخلق — مفتوح للجميع.' },
    },
  },
  common: { language: 'اللغة', interface: 'الواجهة', close: 'إغلاق', loading: 'جارٍ التحميل…' },
};

export const DICTS: Record<UiLang, Dict> = { fr, en, ar };
export const RTL_LANGS: UiLang[] = ['ar'];
